export function coalesce<V, F extends V | null>(...args: [...[boolean, V][], [true, F]]) {
  // @README there should always be 1 fallback item at the end
  return args.find(([condition]) => condition)?.[1] || args[args.length - 1][1]
}